/** Literal `\n` escape sequences, CRLF, and lone CR line endings — normalised to LF before hard-break conversion. */
export const NON_STANDARD_NEW_LINE_REGEX = /\\n|\r\n|\r/g;

/** A run of one or more newlines, absorbing any whitespace-only lines between them. */
export const NEW_LINE_RUN_REGEX = /\n(?:[ \t]*\n)*/g;

/**
 * A fenced code block (``` or ~~~), including an unclosed fence running to the end of the string. Content inside
 * fences must not be rewritten — hard-break backslashes would corrupt the code. The closing fence consumes its
 * trailing newline so the following segment never starts mid-line.
 */
export const FENCED_CODE_REGEX =
    /((?:^|(?<=\n))(?:`{3,}|~{3,})[^\n]*(?:\n[\s\S]*?)?(?:\n(?:`{3,}|~{3,})[ \t]*(?:\n|$)|$))/;

/**
 * A line that begins a continuable container block — a list item or blockquote. A single newline after one can
 * safely become a hard break inside the item, but a blank-line run must stay real so following text is not pulled
 * into the container as a lazy continuation.
 */
export const CONTAINER_LINE_REGEX = /^ {0,3}(?:[-*+](?:[ \t]|$)|\d{1,9}[.)](?:[ \t]|$)|>)/;

/**
 * A block-syntax line that terminates at its line ending — heading, table row, fence, horizontal rule, setext
 * underline, or indented code. A hard break next to one of these would leave a stray backslash, so the surrounding
 * newlines stay real.
 */
export const TERMINAL_LINE_REGEX =
    /^ {0,3}(?:#{1,6}(?:[ \t]|$)|\||`{3,}|~{3,}|([-*_])[ \t]*(?:\1[ \t]*){2,}$|=+[ \t]*$)|^[ \t]{4,}\S/;

export const ESCAPE_NUMBERS_REGEX = /(^|\n)(\d+)\.(\s|$)/g;

/** The writing-issue marker syntax: `**issueStart[className,description]textissueEnd**`. */
export const STRONG_CLASSNAME_REGEX = /issueStart\[(.*),(.*)\]([\s\S]*)issueEnd/;

/** The class-name marker syntax: `**classNameStart[className,description]textclassNameEnd**`. */
export const CLASSNAME_REGEX = /classNameStart\[(.*),(.*)\]([\s\S]*)classNameEnd/;

/** How long the attachment placeholder's copy control shows its "Copied" confirmation, in milliseconds. */
export const COPY_FEEDBACK_TIMEOUT = 2000;
